import { IConfig } from '@cian/config/shared';
import { IApplicationContext } from 'shared/mf-infrastructure/types/applicationContext';

const LOGO_REDESIGN_ENABLED_KEY = 'BX.LogoRedesign.2026.Enabled';

let isLogoRedesignEnabled = false;

export function readIsLogoRedesignEnabled(config: IConfig): boolean {
  return config.get<boolean>(LOGO_REDESIGN_ENABLED_KEY) || false;
}

export function initIsLogoRedesignEnabled(context: IApplicationContext): void {
  try {
    isLogoRedesignEnabled = readIsLogoRedesignEnabled(context.config);
  } catch {
    isLogoRedesignEnabled = false;
  }
}

export function getIsLogoRedesignEnabled(): boolean {
  return isLogoRedesignEnabled;
}
